import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { InfectionControlCategoriesService, InfectionControlCategoryInterface } from './infection-control-categories.service';
import { Subject } from 'rxjs';
import { ModalService, SelectizeComponent } from '../../blocks';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-infection-control-categories',
  templateUrl: './infection-control-categories.component.html',
  styleUrls: ['./infection-control-categories.component.css']
})
export class InfectionControlCategoriesComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  categoriesList: InfectionControlCategoryInterface[] = [];
  subCategoriesList: InfectionControlCategoryInterface[] = [];
  interventionList: InfectionControlCategoryInterface[] = [];
  categoriesObj = <InfectionControlCategoryInterface>{};
  subCategoriesObj = <InfectionControlCategoryInterface>{};
  interventionObj = <InfectionControlCategoryInterface>{};

  constructor(private _infSer: InfectionControlCategoriesService, private _modalService: ModalService, public translate: TranslateService) { }
  ngOnInit() {
    this.getInfectionControlCategoriesList();
  }


 
  // Category area\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\Azmestic 13-8-2024
  getInfectionControlCategoriesList() {
    this.categoriesList = [];
    this.interventionList = [];
    this.subCategoriesList = [];
    this.categoriesObj.level = 1;
    this.categoriesObj.parentSerial = 0;
    this._infSer.getInfectionControlCategoriesList(this.categoriesObj)
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.categoriesList = res.data;
          }
        },
        error => console.log(error),
        () => {
        });
  }
  addCategoryRow() {
    this.categoriesList.push(<InfectionControlCategoryInterface>{
      serial: (this.categoriesList.length + 1) * -1,
      dataStatus: 1,
      level: 1,
      isActive: 1,

      parentSerial: 0
    })

  }
  onCategoryIconClicked(actioncode: number, obj: InfectionControlCategoryInterface) {
    this.categoriesObj = obj;
    if (actioncode == 404) {
      this.getSubCategoryList()
    }
    if (actioncode == 307) {
      this.editCategoryRow(obj)
    }
    if (actioncode == 3) {
      this.deleteCategoryRow(obj)
    }
  }
  editCategoryRow(obj) {
    obj.dataStatus = 2;
  }
  deleteCategoryRow(obj) {
    if (obj.serial > 0) {
      this._modalService.activeDelMes(obj.descAr, obj.descEn).then(responseOK => {
        if (responseOK) {
          this._infSer.deleteInfectionControlCategory(obj.serial)
            .subscribe(
              res => {
                this.getInfectionControlCategoriesList()
              },
              error => console.log(error),
              () => {
              });
        }
      })
    }
    else {
      let ind = this.categoriesList.indexOf(obj);
      this.categoriesList.splice(ind, 1);
    }
  }

  onCategorySaveClicked() {
    if (this.categoriesList.length > 0) {
      this._infSer.addInfectionControlCategory(this.categoriesList)
        .subscribe(
          res => {
            this.getInfectionControlCategoriesList()
          },
          error => console.log(error),
          () => {
          });

    }

  }
  isActiveChange(ev: any, obj: any) {
    if (ev.target.checked) {
      obj.isActive = 1
    } else {
      obj.isActive = 0
    }
  }
  // Sub Category area\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\Azmestic 13-8-2024
  getSubCategoryList() {
    this.subCategoriesList = [];
    this.interventionList = [];
    this.subCategoriesObj.parentSerial = this.categoriesObj.serial;
    this.subCategoriesObj.level = 2;
    if (this.subCategoriesObj.parentSerial > 0) {
      this._infSer.getInfectionControlCategoriesList(this.subCategoriesObj)
        .subscribe(
          res => {
            if (res && res.data && res.data.length > 0) {
              this.subCategoriesList = res.data;
            }
          },
          error => console.log(error),
          () => {
          });
    }

  }
  addSubCategoryRow() {
    this.subCategoriesList.push(<InfectionControlCategoryInterface>{
      serial: (this.subCategoriesList.length + 1) * -1,
      dataStatus: 1,
      level: 2,
      isActive: 1,
      parentSerial: this.categoriesObj.serial
    })
  }
  onSubCategoryIconClicked(actioncode: number, obj: InfectionControlCategoryInterface) {
    this.subCategoriesObj = obj;
    if (actioncode == 404) {
      this.getInterventionList()
    }
    if (actioncode == 307) {
      this.editSubCategoryRow(obj)
    }
    if (actioncode == 3) {
      this.deleteSubCategoryRow(obj)
    }



  }
  editSubCategoryRow(obj) {
    obj.dataStatus = 2;
  }
  deleteSubCategoryRow(obj) {
    if (obj.serial > 0) {
      this._modalService.activeDelMes(obj.descAr, obj.descEn).then(responseOK => {
        if (responseOK) {
          this._infSer.deleteInfectionControlCategory(obj.serial)
            .subscribe(
              res => {
                this.getSubCategoryList()
              },
              error => console.log(error),
              () => {
              });
        }
      })



    }
    else {
      let ind = this.subCategoriesList.indexOf(obj);
      this.subCategoriesList.splice(ind, 1);
    }
  }
  onSubCategorySaveClicked() {
    if (this.subCategoriesList.length > 0) {
      this._infSer.addInfectionControlCategory(this.subCategoriesList)
        .subscribe(
          res => {
            this.getSubCategoryList()
          },
          error => console.log(error),
          () => {
          });

    }
  }
  // Intervention area\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\Azmestic 13-8-2024
  getInterventionList() {
    this.interventionList = [];
    this.interventionObj.parentSerial = this.subCategoriesObj.serial;
    this.interventionObj.level = 3;
    if (this.interventionObj.parentSerial > 0) {
      this._infSer.getInfectionControlCategoriesList(this.interventionObj)
        .subscribe(
          res => {
            if (res && res.data && res.data.length > 0) {
              this.interventionList = res.data;
            }
          },
          error => console.log(error),
          () => {
          });
    }
  }
  addInterventionRow() {
    this.interventionList.push(<InfectionControlCategoryInterface>{
      serial: (this.interventionList.length + 1) * -1,
      dataStatus: 1,
      level: 3,
      isActive: 1,
      parentSerial: this.subCategoriesObj.serial
    })
  }
  onInterventionIconClicked(actioncode: number, obj: InfectionControlCategoryInterface) {
    this.interventionObj = obj;
    if (actioncode == 307) {
      this.editInterventionRow(obj)
    }
    if (actioncode == 3) {
      this.deleteInterventionRow(obj)
    }
  }
  editInterventionRow(obj) {
    obj.dataStatus = 2;
  }
  deleteInterventionRow(obj) {
    if (obj.serial > 0) {
      this._modalService.activeDelMes(obj.descAr, obj.descEn).then(responseOK => {
        if (responseOK) {
          this._infSer.deleteInfectionControlCategory(obj.serial)
            .subscribe(
              res => {
                this.getInterventionList()
              },
              error => console.log(error),
              () => {
              });
        }
      })
    }
    else {
      let ind = this.interventionList.indexOf(obj);
      this.interventionList.splice(ind, 1);
    }
  }


  onInterventionSaveClicked(obj: any) {
    if (this.interventionList.length > 0) {
      this._infSer.addInfectionControlCategory(this.interventionList)
        .subscribe(
          res => {
            this.getInterventionList()
          },
          error => console.log(error),
          () => {
          });

    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  categories: any[] = [
    {
      name: {
        en: 'Hand Hygiene',
        ar: 'نظافة اليدين'
      },
      subcategories: [
        {
          name: {
            en: 'Proper Handwashing Technique',
            ar: 'تقنية غسل اليدين الصحيحة'
          },
          interventions: [
            {
              en: 'Ensure staff wash hands for at least 20 seconds.',
              ar: 'تأكد من غسل اليدين لمدة لا تقل عن 20 ثانية.'
            },
            {
              en: 'Focus on cleaning fingertips, nails, and between fingers.',
              ar: 'ركز على تنظيف أطراف الأصابع والأظافر وبين الأصابع.'
            },
            {
              en: 'Use soap and water or an alcohol-based hand rub.',
              ar: 'استخدم الصابون والماء أو معقم يدين يحتوي على الكحول.'
            }
          ]
        },
        {
          name: {
            en: 'Use of Alcohol-based Hand Sanitizers',
            ar: 'استخدام معقمات اليدين التي تحتوي على الكحول'
          },
          interventions: [
            {
              en: 'Ensure availability at key locations.',
              ar: 'تأكد من توفره في الأماكن الرئيسية.'
            },
            {
              en: 'Ensure sanitizer contains at least 60% alcohol.',
              ar: 'تأكد من أن المعقم يحتوي على نسبة كحول لا تقل عن 60%.'
            }
          ]
        },
        {
          name: {
            en: 'Hand Hygiene Compliance Monitoring',
            ar: 'مراقبة امتثال نظافة اليدين'
          },
          interventions: [
            {
              en: 'Regular audits of hand hygiene practices.',
              ar: 'إجراء تدقيقات منتظمة لممارسات نظافة اليدين.'
            },
            {
              en: 'Feedback mechanisms for staff compliance.',
              ar: 'آليات التغذية الراجعة لامتثال الموظفين.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Sterilization and Disinfection',
        ar: 'التعقيم والتنظيف'
      },
      subcategories: [
        {
          name: {
            en: 'High-level Disinfection',
            ar: 'التنظيف على مستوى عالٍ'
          },
          interventions: [
            {
              en: 'Use chemical disinfectants for medical equipment.',
              ar: 'استخدم المطهرات الكيميائية للمعدات الطبية.'
            },
            {
              en: 'Ensure proper contact time and temperature.',
              ar: 'تأكد من وقت وت temperature التواصل الصحيح.'
            }
          ]
        },
        {
          name: {
            en: 'Low-level Disinfection',
            ar: 'التنظيف على مستوى منخفض'
          },
          interventions: [
            {
              en: 'Routine cleaning of environmental surfaces.',
              ar: 'تنظيف الروتين للأسطح البيئية.'
            },
            {
              en: 'Use appropriate disinfectants for non-critical items.',
              ar: 'استخدم المطهرات المناسبة للأشياء غير الحرجة.'
            }
          ]
        },
        {
          name: {
            en: 'Sterilization of Surgical Instruments',
            ar: 'تعقيم الأدوات الجراحية'
          },
          interventions: [
            {
              en: 'Use autoclaves or other sterilization methods.',
              ar: 'استخدم الأوتوكلافات أو طرق التعقيم الأخرى.'
            },
            {
              en: 'Ensure instruments are properly cleaned before sterilization.',
              ar: 'تأكد من تنظيف الأدوات بشكل صحيح قبل التعقيم.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Waste Management',
        ar: 'إدارة النفايات'
      },
      subcategories: [
        {
          name: {
            en: 'Segregation of Waste',
            ar: 'فصل النفايات'
          },
          interventions: [
            {
              en: 'Separate infectious waste from non-infectious waste.',
              ar: 'افصل النفايات المعدية عن النفايات غير المعدية.'
            },
            {
              en: 'Use color-coded bins for different waste types.',
              ar: 'استخدم الحاويات الملونة لأنواع النفايات المختلفة.'
            }
          ]
        },
        {
          name: {
            en: 'Safe Disposal of Sharps',
            ar: 'التخلص الآمن من الأدوات الحادة'
          },
          interventions: [
            {
              en: 'Use puncture-resistant containers for sharps disposal.',
              ar: 'استخدم حاويات مقاومة للثقب للتخلص من الأدوات الحادة.'
            },
            {
              en: 'Ensure proper sealing and disposal of containers.',
              ar: 'تأكد من إغلاق الحاويات بشكل صحيح والتخلص منها.'
            }
          ]
        },
        {
          name: {
            en: 'Handling of Hazardous Waste',
            ar: 'التعامل مع النفايات الخطرة'
          },
          interventions: [
            {
              en: 'Train staff on safe handling and disposal procedures.',
              ar: 'قم بتدريب الموظفين على إجراءات التعامل والتخلص الآمن.'
            },
            {
              en: 'Ensure proper PPE is worn during waste handling.',
              ar: 'تأكد من ارتداء معدات الحماية الشخصية المناسبة أثناء التعامل مع النفايات.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Personal Protective Equipment (PPE)',
        ar: 'معدات الحماية الشخصية (PPE)'
      },
      subcategories: [
        {
          name: {
            en: 'Proper Use of Gloves',
            ar: 'الاستخدام الصحيح للقفازات'
          },
          interventions: [
            {
              en: 'Change gloves between tasks and when contaminated.',
              ar: 'قم بتغيير القفازات بين المهام وعند التلوث.'
            },
            {
              en: 'Avoid touching face or adjusting PPE with contaminated gloves.',
              ar: 'تجنب لمس الوجه أو ضبط معدات الحماية الشخصية بالقفازات الملوثة.'
            }
          ]
        },
        {
          name: {
            en: 'Gowns and Aprons',
            ar: 'العباءات والمرايل'
          },
          interventions: [
            {
              en: 'Use appropriate gowns/aprons for tasks involving exposure to bodily fluids.',
              ar: 'استخدم العباءات/المرايل المناسبة للمهام التي تنطوي على التعرض للسوائل الجسمية.'
            },
            {
              en: 'Dispose of gowns appropriately after use.',
              ar: 'تخلص من العباءات بشكل مناسب بعد الاستخدام.'
            }
          ]
        },
        {
          name: {
            en: 'Masks and Respirators',
            ar: 'الأقنعة وأجهزة التنفس'
          },
          interventions: [
            {
              en: 'Ensure correct fitting and usage of masks and respirators.',
              ar: 'تأكد من التوافق الصحيح واستخدام الأقنعة وأجهزة التنفس.'
            },
            {
              en: 'Dispose of single-use masks properly.',
              ar: 'تخلص من الأقنعة ذات الاستخدام الواحد بشكل صحيح.'
            }
          ]
        },
        {
          name: {
            en: 'Face Shields and Goggles',
            ar: 'واقيات الوجه والنظارات الواقية'
          },
          interventions: [
            {
              en: 'Clean and disinfect reusable face shields and goggles.',
              ar: 'نظف وعرّض واقيات الوجه والنظارات الواقية القابلة لإعادة الاستخدام للتعقيم.'
            },
            {
              en: 'Ensure proper fit to provide full coverage.',
              ar: 'تأكد من التوافق الصحيح لتوفير تغطية كاملة.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Environmental Cleaning',
        ar: 'تنظيف البيئة'
      },
      subcategories: [
        {
          name: {
            en: 'Daily Cleaning Protocols',
            ar: 'بروتوكولات التنظيف اليومية'
          },
          interventions: [
            {
              en: 'Clean high-touch surfaces frequently.',
              ar: 'نظف الأسطح التي يتم لمسها بشكل متكرر.'
            },
            {
              en: 'Use approved disinfectants for healthcare settings.',
              ar: 'استخدم المطهرات المعتمدة للإعدادات الصحية.'
            }
          ]
        },
        {
          name: {
            en: 'Terminal Cleaning after Patient Discharge',
            ar: 'التنظيف النهائي بعد خروج المريض'
          },
          interventions: [
            {
              en: 'Perform thorough cleaning and disinfection of rooms after patient discharge.',
              ar: 'قم بإجراء تنظيف وتعقيم شامل للغرف بعد خروج المريض.'
            },
            {
              en: 'Follow hospital protocols for terminal cleaning.',
              ar: 'اتبع بروتوكولات المستشفى للتنظيف النهائي.'
            }
          ]
        },
        {
          name: {
            en: 'Use of Disinfectants',
            ar: 'استخدام المطهرات'
          },
          interventions: [
            {
              en: 'Use EPA-approved disinfectants.',
              ar: 'استخدم المطهرات المعتمدة من وكالة حماية البيئة (EPA).'
            },
            {
              en: 'Follow manufacturer instructions for use.',
              ar: 'اتبع تعليمات الشركة المصنعة للاستخدام.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Antibiotic Stewardship',
        ar: 'إدارة المضادات الحيوية'
      },
      subcategories: [
        {
          name: {
            en: 'Guidelines for Antibiotic Prescribing',
            ar: 'إرشادات وصف المضادات الحيوية'
          },
          interventions: [
            {
              en: 'Adhere to hospital protocols for prescribing antibiotics.',
              ar: 'اتبع بروتوكولات المستشفى لوصف المضادات الحيوية.'
            },
            {
              en: 'Avoid unnecessary use of broad-spectrum antibiotics.',
              ar: 'تجنب الاستخدام غير الضروري للمضادات الحيوية واسعة النطاق.'
            }
          ]
        },
        {
          name: {
            en: 'Monitoring Antibiotic Use',
            ar: 'مراقبة استخدام المضادات الحيوية'
          },
          interventions: [
            {
              en: 'Regularly review and monitor antibiotic prescriptions.',
              ar: 'قم بمراجعة ومراقبة وصفات المضادات الحيوية بانتظام.'
            },
            {
              en: 'Provide feedback to prescribers on antibiotic usage.',
              ar: 'قدّم تغذية راجعة للمصفين حول استخدام المضادات الحيوية.'
            }
          ]
        },
        {
          name: {
            en: 'Education on Antibiotic Resistance',
            ar: 'التعليم حول مقاومة المضادات الحيوية'
          },
          interventions: [
            {
              en: 'Educate staff on the importance of responsible antibiotic use.',
              ar: 'قم بتثقيف الموظفين حول أهمية استخدام المضادات الحيوية بشكل مسؤول.'
            },
            {
              en: 'Provide training on preventing antibiotic resistance.',
              ar: 'قدّم تدريبًا على كيفية منع مقاومة المضادات الحيوية.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Vaccination Protocols',
        ar: 'بروتوكولات التطعيم'
      },
      subcategories: [
        {
          name: {
            en: 'Staff Immunization',
            ar: 'تطعيم الموظفين'
          },
          interventions: [
            {
              en: 'Ensure staff are up-to-date on recommended vaccinations.',
              ar: 'تأكد من أن الموظفين على اطلاع بأحدث التطعيمات الموصى بها.'
            },
            {
              en: 'Maintain accurate records of staff immunizations.',
              ar: 'حافظ على سجلات دقيقة لتطعيمات الموظفين.'
            }
          ]
        },
        {
          name: {
            en: 'Patient Immunization',
            ar: 'تطعيم المرضى'
          },
          interventions: [
            {
              en: 'Provide vaccinations to eligible patients.',
              ar: 'قدم التطعيمات للمرضى المؤهلين.'
            },
            {
              en: 'Monitor and document patient vaccination status.',
              ar: 'راقب ووثق حالة تطعيم المرضى.'
            }
          ]
        },
        {
          name: {
            en: 'Vaccine Storage and Handling',
            ar: 'تخزين وتداول اللقاحات'
          },
          interventions: [
            {
              en: 'Ensure vaccines are stored at correct temperatures.',
              ar: 'تأكد من تخزين اللقاحات عند درجات الحرارة الصحيحة.'
            },
            {
              en: 'Follow protocols for safe handling of vaccines.',
              ar: 'اتبع البروتوكولات الخاصة بالتعامل الآمن مع اللقاحات.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Patient Isolation Precautions',
        ar: 'احتياطات عزل المرضى'
      },
      subcategories: [
        {
          name: {
            en: 'Standard Precautions',
            ar: 'الاحتياطات القياسية'
          },
          interventions: [
            {
              en: 'Use PPE as required for all patient care activities.',
              ar: 'استخدم معدات الحماية الشخصية حسب الحاجة لجميع أنشطة رعاية المرضى.'
            },
            {
              en: 'Ensure hand hygiene is performed before and after patient contact.',
              ar: 'تأكد من أداء نظافة اليدين قبل وبعد الاتصال بالمريض.'
            }
          ]
        },
        {
          name: {
            en: 'Contact Precautions',
            ar: 'احتياطات الاتصال'
          },
          interventions: [
            {
              en: 'Use gowns and gloves for contact with patients or their environment.',
              ar: 'استخدم العباءات والقفازات عند الاتصال بالمرضى أو بيئتهم.'
            },
            {
              en: 'Place patients in a private room when possible.',
              ar: 'ضع المرضى في غرفة خاصة إذا كان ذلك ممكنًا.'
            }
          ]
        },
        {
          name: {
            en: 'Droplet Precautions',
            ar: 'احتياطات الرذاذ'
          },
          interventions: [
            {
              en: 'Wear masks for close contact with patients.',
              ar: 'ارتدِ الأقنعة عند الاتصال الوثيق بالمرضى.'
            },
            {
              en: 'Ensure proper placement of patients to reduce droplet spread.',
              ar: 'تأكد من وضع المرضى بشكل مناسب لتقليل انتشار الرذاذ.'
            }
          ]
        },
        {
          name: {
            en: 'Airborne Precautions',
            ar: 'احتياطات الهواء'
          },
          interventions: [
            {
              en: 'Use N95 respirators for staff caring for patients with airborne diseases.',
              ar: 'استخدم أجهزة تنفس N95 للموظفين الذين يعتنون بالمرضى المصابين بأمراض تنتقل عبر الهواء.'
            },
            {
              en: 'Ensure negative pressure rooms for patients when necessary.',
              ar: 'تأكد من وجود غرف ضغط سلبي للمرضى عند الضرورة.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Infection Surveillance',
        ar: 'مراقبة العدوى'
      },
      subcategories: [
        {
          name: {
            en: 'Monitoring Infection Rates',
            ar: 'مراقبة معدلات العدوى'
          },
          interventions: [
            {
              en: 'Regularly track and analyze infection rates.',
              ar: 'تتبع وتحليل معدلات العدوى بانتظام.'
            },
            {
              en: 'Identify trends and implement preventive measures.',
              ar: 'تحديد الاتجاهات وتطبيق التدابير الوقائية.'
            }
          ]
        },
        {
          name: {
            en: 'Reporting Infections',
            ar: 'تقرير العدوى'
          },
          interventions: [
            {
              en: 'Report infections to the appropriate authorities.',
              ar: 'الإبلاغ عن العدوى إلى السلطات المعنية.'
            },
            {
              en: 'Ensure timely and accurate reporting.',
              ar: 'تأكد من الإبلاغ في الوقت المناسب وبشكل دقيق.'
            }
          ]
        },
        {
          name: {
            en: 'Outbreak Investigation',
            ar: 'التحقيق في التفشي'
          },
          interventions: [
            {
              en: 'Conduct thorough investigations during outbreaks.',
              ar: 'قم بإجراء تحقيقات شاملة أثناء التفشي.'
            },
            {
              en: 'Implement corrective actions and preventive measures.',
              ar: 'تنفيذ إجراءات تصحيحية وتدابير وقائية.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Water Safety and Infection Control',
        ar: 'سلامة المياه ومراقبة العدوى'
      },
      subcategories: [
        {
          name: {
            en: 'Legionella Prevention',
            ar: 'الوقاية من الليجيونيلا'
          },
          interventions: [
            {
              en: 'Regularly test water systems for Legionella.',
              ar: 'قم باختبار أنظمة المياه بانتظام للكشف عن الليجيونيلا.'
            },
            {
              en: 'Implement control measures to prevent Legionella growth.',
              ar: 'تطبيق تدابير التحكم لمنع نمو الليجيونيلا.'
            }
          ]
        },
        {
          name: {
            en: 'Safe Water Practices in Healthcare',
            ar: 'ممارسات المياه الآمنة في الرعاية الصحية'
          },
          interventions: [
            {
              en: 'Ensure the use of sterile water in medical procedures.',
              ar: 'تأكد من استخدام الماء المعقم في الإجراءات الطبية.'
            },
            {
              en: 'Monitor and maintain water quality in healthcare settings.',
              ar: 'راقب وحافظ على جودة المياه في بيئات الرعاية الصحية.'
            }
          ]
        },
        {
          name: {
            en: 'Waterborne Infection Monitoring',
            ar: 'مراقبة العدوى المنقولة بالماء'
          },
          interventions: [
            {
              en: 'Regularly monitor for waterborne infections.',
              ar: 'راقب بانتظام العدوى المنقولة بالماء.'
            },
            {
              en: 'Implement preventive measures to control outbreaks.',
              ar: 'تنفيذ التدابير الوقائية للتحكم في التفشي.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Staff Education and Training',
        ar: 'تدريب وتعليم الموظفين'
      },
      subcategories: [
        {
          name: {
            en: 'Infection Control Training Programs',
            ar: 'برامج تدريب مكافحة العدوى'
          },
          interventions: [
            {
              en: 'Provide initial and ongoing training to staff.',
              ar: 'قدّم التدريب الأولي والمستمر للموظفين.'
            },
            {
              en: 'Ensure training covers all relevant infection control protocols.',
              ar: 'تأكد من أن التدريب يشمل جميع بروتوكولات مكافحة العدوى ذات الصلة.'
            }
          ]
        },
        {
          name: {
            en: 'Ongoing Education',
            ar: 'التعليم المستمر'
          },
          interventions: [
            {
              en: 'Provide regular updates and refresher courses.',
              ar: 'قدّم تحديثات منتظمة ودورات تجديد.'
            },
            {
              en: 'Encourage staff to stay informed on the latest practices.',
              ar: 'شجع الموظفين على البقاء على اطلاع بأحدث الممارسات.'
            }
          ]
        },
        {
          name: {
            en: 'Competency Assessments',
            ar: 'تقييمات الكفاءة'
          },
          interventions: [
            {
              en: 'Regularly assess staff competencies in infection control.',
              ar: 'قم بتقييم كفاءات الموظفين في مكافحة العدوى بانتظام.'
            },
            {
              en: 'Provide feedback and additional training as needed.',
              ar: 'قدّم تغذية راجعة وتدريبًا إضافيًا حسب الحاجة.'
            }
          ]
        }
      ]
    },
    {
      name: {
        en: 'Reporting and Documentation',
        ar: 'التقرير والتوثيق'
      },
      subcategories: [
        {
          name: {
            en: 'Accurate Record-Keeping',
            ar: 'تسجيل السجلات بدقة'
          },
          interventions: [
            {
              en: 'Ensure all infection control activities are properly documented.',
              ar: 'تأكد من توثيق جميع أنشطة مكافحة العدوى بشكل صحيح.'
            },
            {
              en: 'Maintain accurate records of infections, audits, and training.',
              ar: 'حافظ على سجلات دقيقة للعدوى والتدقيق والتدريب.'
            }
          ]
        },
        {
          name: {
            en: 'Incident Reporting',
            ar: 'تقرير الحوادث'
          },
          interventions: [
            {
              en: 'Report incidents promptly to the appropriate authorities.',
              ar: 'الإبلاغ عن الحوادث على الفور إلى السلطات المختصة.'
            },
            {
              en: 'Ensure thorough documentation of incidents and corrective actions.',
              ar: 'تأكد من توثيق شامل للحوادث والإجراءات التصحيحية.'
            }
          ]
        },
        {
          name: {
            en: 'Compliance with Regulations',
            ar: 'الامتثال للوائح'
          },
          interventions: [
            {
              en: 'Ensure adherence to local, national, and international regulations.',
              ar: 'تأكد من الالتزام باللوائح المحلية والوطنية والدولية.'
            },
            {
              en: 'Document compliance efforts and corrective actions.',
              ar: 'وثق جهود الامتثال والإجراءات التصحيحية.'
            }
          ]
        }
      ]
    }
  ];


}
